<script lang="ts" setup>
import dayjs from '@sancare/typescript-commons/src/misc/dayjs'
import { lowerFirst } from '@sancare/typescript-commons/src/misc/string-utils'
import { computed, onMounted, watch } from 'vue'

import { useStore } from '@/store'
import { PmsiTypeEnum } from '@/store/modules/settings/types'

const store = useStore()
const props = defineProps<{
  pmsiType: PmsiTypeEnum
  pmsiId: string
}>()

const stayStatusList = computed(() => {
  const statusList = store.state.maintenance.stayStatusList
  if (!statusList) return []

  return statusList
    .filter((status) => status.lastSeen)
    .sort((a, b) => {
      const dateA = new Date(a.lastSeen).getTime()
      const dateB = new Date(b.lastSeen).getTime()
      return dateB - dateA
    })
})

const stayStatusListRequest = computed(() => store.state.maintenance.requests.getStayStatusListRequest)

onMounted(refresh)
watch(() => [props.pmsiId, props.pmsiType], refresh)

function refresh() {
  if ((stayStatusListRequest.value.fetching || stayStatusListRequest.value.ok)) {
    return
  }
  store.dispatch('getStayStatusList', { pmsiId: props.pmsiId, pmsiType: props.pmsiType })
}

function getLastSeenDate(stayStatus) {
  return `${dayjs(stayStatus.lastSeen).format('L')} à ${dayjs(stayStatus.lastSeen).format('LTS')}`
}

function getStatusLabel(stayStatus) {
  return lowerFirst(stayStatus.statusValueLabel)
}
</script>


<template>
  <div>
    <div
      v-if="stayStatusListRequest.fetching"
      class="loader loader-lg loader-center mb-4"
    />
    <div
      v-else-if="!stayStatusListRequest.ok || stayStatusListRequest.error"
    >
      Erreur: {{ stayStatusListRequest.error }}
    </div>
    <div
      v-else-if="stayStatusList.length === 0"
    >
      Aucun historique à afficher pour l'identifiant {{ pmsiType === PmsiTypeEnum.MCO ? 'RSS' : 'SMR' }} {{ pmsiId }}
    </div>
    <div v-else>
      <div
        v-for="stayStatus in stayStatusList"
        :key="stayStatus.id"
        class="card mb-3"
      >
        <div class="row m-3">
          <div class="col-auto">
            <h2>
              {{ getLastSeenDate(stayStatus) }}
            </h2>
          </div>
          <div class="col">
            Séjour {{ getStatusLabel(stayStatus) }} le {{ getLastSeenDate(stayStatus) }} par {{
              stayStatus.user.firstName && stayStatus.user.lastName ? stayStatus.user.firstName + ' ' + stayStatus.user.lastName : stayStatus.user.username
            }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
h2 {
  font-size: 1.1rem;
}
</style>
